import { Box, Container, Grid, Typography } from "@mui/material"
import { useApiGet } from "auth/useApi2"
import ClpTable from "components/ClpTable"
import { GlobalLoaderContext } from "components/GlobalLoadingProvider"
import { apiEndpoints } from "generated/apiEndpoints"
import moment from "moment"
import { MonthPicker } from "pages/planning/components/MonthPicker"
import { YearPicker } from "pages/planning/components/YearPicker"
import { useContext, useEffect, useMemo, useState } from "react"
import { StyledTableContainer } from "shared/styled/Global"
import { useTranslation } from "react-i18next"

const Schedule = () => {
  const loadingContext = useContext(GlobalLoaderContext)
  const [scheduleResult, getSchedule] = useApiGet()
  const { t } = useTranslation()
  const [year, setYear] = useState(moment())
  const [month, setMonth] = useState(moment().format("MM"))

  useEffect(() => {
    getSchedule(
      apiEndpoints.planning.getschedule
        .replace("{year}", moment(year).format("YYYY"))
        .replace("{month}", month)
    )
  }, [getSchedule, year, month])

  useEffect(() => {
    loadingContext.setLoading(() => scheduleResult.status === 1)
  })

  const columns = useMemo(
    () => [
      {
        accessorFn: (row) => {
          return row.starttid ? moment(row.starttid).format("YYYY-MM-DD") : ""
        },
        header: t("global.date", "Date")
      },
      {
        accessorKey: "starttidDayName",
        header: t("global.day", "Day")
      },
      {
        accessorFn: (row) => {
          return row.starttid ? moment(row.starttid).format("HH:mm") : ""
        },
        header: t("planning.start_time", "Start time")
      },
      {
        accessorFn: (row) => {
          return row.sluttid ? moment(row.sluttid).format("HH:mm") : ""
        },
        header: t("planning.end_time", "End time")
      },
      {
        accessorKey: "beskrivning",
        header: t("planning.service", "Service")
      }
    ],
    []
  )

  return (
    <div>
      <Container>
        <Box>
          <Typography variant="h1">{t("planning.schedule", "Schedule")}</Typography>
        </Box>
      </Container>
      <StyledTableContainer>
        <Box pt={{ xs: 2, sm: 3 }} px={{ xs: 2, sm: 3 }}>
          <Grid container direction="row" justifyContent="flex-end" alignItems="center" spacing={3}>
            <Grid item>
              <YearPicker year={year} setYear={setYear} />
            </Grid>
            <Grid item>
              <MonthPicker month={month} setMonth={setMonth} />
            </Grid>
          </Grid>
        </Box>

        <ClpTable
          rows={scheduleResult.status === 2 && scheduleResult.data}
          loadingState={scheduleResult.status}
          columns={columns}
          print
          printTitle={t("planning.schedule", "Schedule")}
        />
      </StyledTableContainer>
    </div>
  )
}

export default Schedule
